<template>
  <div class="bg-gray-1 rounded p-2">
    <div class="row bg-white rounded pt-3 px-3 mx-1">
      <div class="col-sm">
        <div class="d-flex">
          <em class="fas fa-ballot-check pt-1 mr-2 text-orange" />
          <div>
            <span class="font-14 color-secondary-6">SSN Patronal:</span>
            <p class="font-16 font-weight-normal">
              {{ value.ssn }}
              <em
                v-if="hasUnMaskSSNPermission"
                class="fas ml-1"
                :class="[ssnMasked]"
                role="button"
                @click="$emit('toggle-ssn-mask', isSsnMasked)"
              />
            </p>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="d-flex">
          <em class="fas fa-address-book pt-1 mr-2 text-orange" />
          <div>
            <span class="font-14 color-secondary-6">Tipo de Proveedor:</span>
            <p class="font-16 font-weight-normal">
              {{ value.providerTypeName }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="d-flex">
          <em class="fas fa-address-book pt-1 mr-2 text-orange" />
          <div>
            <span class="font-14 color-secondary-6">Nombre:</span>
            <p class="font-16 font-weight-normal">
              {{ value.providerName }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="showPrimaryContactInformation" class="col-sm">
        <div class="d-flex">
          <em class="fas fa-address-book pt-1 mr-2 text-orange" />
          <div>
            <span class="font-14 color-secondary-6">Contacto Primario:</span>
            <p class="font-16 font-weight-normal">
              {{ this.primaryContactFullName }}
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="hasEditPermission && canEdit"
        class="col-sm-1 d-flex align-items-center justify-content-center"
      >
        <action-button
          class="btn-action-size"
          i="fas fa-edit pl-0"
          variant="outline-success pl-2 mb-3"
          @click="$emit('click')"
        />
      </div>
    </div>
    <div class="row px-3 py-2">
      <div class="col-sm pl-4">
        <check-box
          v-if="isCompanyProviderType"
          v-model="value.isIncorporatedCompany"
          class="my-2 check-box__extended"
          disabled
          text="¿Compañía es incorporada?"
        />
        <check-box
          v-if="isIndividualProviderType"
          v-model="value.isServiceAssistant"
          class="my-2 check-box__extended"
          disabled
          text="¿Es Asistente de Servicio?"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CheckBox from 'CheckBox';
import ActionButton from 'ActionButton';
import providerTypes from '@/utils/constants/providerTypes.js';
import { getProviderContacts as _getProviderContacts } from '@/services/provider/provider.api.js';

export default {
  name: 'ProviderHeaderInfo',
  components: {
    CheckBox,
    ActionButton,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    canEdit: {
      type: Boolean,
      default: () => true,
    },
    isSsnMasked: {
      type: Boolean,
      default: () => true,
    },
    showPrimaryContactInformation: {
      type: Boolean,
      default: () => false,
    },
    providerId: {
      type: String,
      default: () => 0,
    },
    primaryContact: {
      type: Object,
      default: () => null,
    },
  },
  async mounted() {
    if (this.showPrimaryContactInformation) {
      await Promise.all([this.populatePrimaryContact()]);
      this.primaryContact = this.contacts.find(
        (item) => item.isPrimaryContactFlag
      );

      this.primaryContactFullName = `${this.primaryContact.nameFirst} ${this.primaryContact.nameLastPaternal} ${this.primaryContact.nameLastMaternal}`;
    }
  },
  data: () => ({
    contacts: [],
    primaryContactFullName: null,
  }),
  methods: {
    async populatePrimaryContact() {
      const { data: response } = await _getProviderContacts(this.providerId);
      this.contacts = response;
    },
  },
  computed: {
    hasEditPermission() {
      return this.userHasPermissions(
        'menu.rempro.providers.view.editinfoprovider'
      );
    },
    isIndividualProviderType() {
      return this.value.providerTypeId === providerTypes.Individual;
    },
    isCompanyProviderType() {
      return this.value.providerTypeId === providerTypes.Company;
    },
    hasUnMaskSSNPermission() {
      return this.userHasPermissions('rempro.providers.display.ssn');
    },
    ssnMasked() {
      return this.isSsnMasked ? 'fa-eye' : 'fa-eye-slash';
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.check-box__extended ::v-deep {
  color: map-get($colors, 'gray-6') !important;
}
.btn-action-size {
  width: 40px;
  height: 40px;
}
</style>
